import { SystemIcon } from '@volvo/vcdk-react/SystemIcon';

import HardwareHealthCheck from 'assets/volvoIcons/Tools/HardwareHealthCheck';
import ServiceContracts from 'assets/volvoIcons/Tools/ServiceContracts';
import { AreaName } from 'domain/constants';
import { TabConfiguration } from 'library/components/controls/layout/tabs/types';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';
import {
	UnitOVerview_Services_ServiceContracts,
	UnitOverview_Services_HealthChecks,
	UnitOverview_Services_Repairs,
	UnitOverview_Services_ServiceAgreements,
	UnitOverview_Services_ServiceProtocols,
} from 'main/routes/urls/RouteUrls';

// #1600840 - TODO: REMOVE AFTER PROD RELEASE
const isServiceContractFeatureOn = () =>
	import.meta.env.VITE_IS_SERVICE_CONTRACT === 'true';

export const servicesAreaTabsConfiguration: TabConfiguration[] = [
	{
		title: 'productIndividual:repairs-title',
		path: UnitOverview_Services_Repairs,
		icon: <SystemIcon icon="wrench" aria-label="Repairs" />,
		areaSecurity: createArea(AreaName.Repair, OperationType.Read),
	},
	{
		title: 'drivelineview:protocolsSection',
		path: UnitOverview_Services_ServiceProtocols,
		icon: <SystemIcon icon="service" aria-label="Service Protocols" />,
		areaSecurity: createArea(AreaName.ServiceProtocol, OperationType.Read),
	},
	{
		title: 'unitOverview:service-agreements-title',
		path: UnitOverview_Services_ServiceAgreements,
		icon: <SystemIcon icon="handshake" aria-label="Service Agreements" />,
	},
	{
		title: 'unitOverview:health-checks-title',
		path: UnitOverview_Services_HealthChecks,
		icon: <HardwareHealthCheck aria-label="Health Checks" />,
		endDateNewBadge: new Date(2026, 10, 1),
		areaSecurity: createArea(AreaName.HealthCheck, OperationType.Read),
	},
];

if (isServiceContractFeatureOn()) {
	servicesAreaTabsConfiguration.push({
		title: 'unitOverview:service-contracts',
		path: UnitOVerview_Services_ServiceContracts,
		icon: <ServiceContracts aria-label="Service Contracts" />,
		endDateNewBadge: new Date(2027, 6, 1),
		areaSecurity: createArea(AreaName.ServiceContracts, OperationType.Read),
	});
}
